/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormColorField, {
  FormColorFieldProps
} from '../../../../client/js/components/form/fields/FormColorField'

function ColorField (props: FormColorFieldProps) {
  const {
    name = 'color',
    ...others
  } = props
  const intl = useIntl()
  return (
    <FormColorField
      label={intl.formatMessage({
        id: 'color',
        defaultMessage: 'Couleur'
      })}
      name={name}
      {...others}
    />
  )
}

export default ColorField
